/**
 * show string: n/20
 * @param count
 */
export const totalStr = (count = 0) => `${count}/${count > 20 ? count : 20}`;
